import { formatUrlId, parseUrlId } from '@cargoflow/validators'
import { createFileRoute } from '@tanstack/react-router'
import { LoadEditFormPage } from '@/features/loads/load-edit-form-page'

export const Route = createFileRoute('/_authenticated/loads/$load_id/edit-form')({
  params: {
    parse: ({ load_id }) => ({ load_id: parseUrlId(load_id) }),
    stringify: ({ load_id }) => ({ load_id: formatUrlId('LD', load_id) }),
  },
  component: LoadEditFormPage,
})
